import React from 'react';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';

export const AppProviders = ({ children }: { children: JSX.Element }) => {
  return (
    <NetworkRoleProvider>
      <BrowserSizeProvider>{children}</BrowserSizeProvider>
    </NetworkRoleProvider>
  );
};
